var Enum = Enum || { MEEDY : {}};

Enum.ATTACHMENT_TYPE = {
    OTHER: 'OTHER',
    EWUS_STATEMENT_BY_AUTHORIZED_PERSON: 'EWUS_STATEMENT_BY_AUTHORIZED_PERSON',
    EWUS_STATEMENT: 'EWUS_STATEMENT',
    EPICRISIS_PDF: 'EPICRISIS_PDF',
    PRESCRIPTION_PDF: 'PRESCRIPTION_PDF',
    REFERRAL_PDF: 'REFERRAL_PDF',
    SICK_LEAVE_PDF: 'SICK_LEAVE_PDF'
};

Object.freeze(Enum.ATTACHMENT_TYPE);